import { Head, Link, usePage } from '@inertiajs/react'
import { Button, Container, Group, Paper, Stack, Text, Title } from '@mantine/core'
import type { SharedProps } from '@/types'

export default function Home() {
  const { current_user } = usePage<SharedProps>().props

  return (
    <>
      <Head title="Artificial Assistant" />

      <Container size="sm" py={96}>
        <Paper p="xl" radius="xl" shadow="md" withBorder>
          <Stack gap="lg" ta="center">
            <Stack gap="sm">
              <Title order={1}>Artificial Assistant</Title>
              <Text c="dimmed" size="lg">
                A multi-agent workspace for autonomous chats, project context, and collaborative memory.
              </Text>
            </Stack>

            <Group justify="center">
              {current_user ? (
                <Button component={Link} href="/dashboard" size="md">
                  Go to Dashboard
                </Button>
              ) : (
                <Button component={Link} href="/users/sign_in" size="md">
                  Sign In
                </Button>
              )}
            </Group>

            {!current_user ? (
              <Text c="dimmed" size="sm">
                Account creation is temporarily disabled.
              </Text>
            ) : null}
          </Stack>
        </Paper>
      </Container>
    </>
  )
}
